<script setup lang="ts">
import { useSnackbarStore } from '@/store/snackbar'

interface IProps {
  modelValue?: boolean,
  dialogTitle?: string,
  userSelectLabel?: string,
  assigneeCampaignId?: number | null | undefined
}

const props = withDefaults(defineProps<IProps>(), {
  modelValue: false,
  dialogTitle: 'User',
  userSelectLabel: 'User',
  assigneeCampaignId: null
})

interface Emit {
  (e: 'update:modelValue', value: boolean): void
  (e: 'onSubmit', value: any[]): void
  (e: 'onClose'): void
}

const emit = defineEmits<Emit>()

const snackbarStore = useSnackbarStore()

const users = ref<any[]>([])
const loading = ref<boolean>(false)

const onSubmit = async () => {
  if (!users.value || !users.value.length) return
  emit('onSubmit', users.value)
  emit('update:modelValue', false)
}

const onClose = async () => {
  emit('onClose')
  users.value = []
}

watch(() => props.modelValue, () => {
  // on show Dialog
  if (!!props.modelValue) {
  }
  // on hide Dialog
  else {
    onClose()
  }
})
</script>

<template>
  <VDialog
    :model-value="modelValue"
    max-width="600"
    :persistent="!!loading"
    @after-leave="onClose"
    @update:modelValue="emit('update:modelValue')"
  >
    <DialogCloseBtn
      :disabled="loading"
      @click="emit('update:modelValue', !modelValue)"
    />

    <VCard :title="dialogTitle">
      <VCardText>
        <VRow>
          <VCol cols="12">
            <MultipleUsersSelect
              v-model="users"
              :label="userSelectLabel"
              :assignee-campaign-id="assigneeCampaignId"
            />
          </VCol>
          <VCol
            class="d-flex justify-end"
            cols="12"
          >
            <VBtn
              :disabled="!!loading || !users.length"
              @click="onSubmit"
            >
              Submit
              <VProgressCircular
                v-if="loading"
                class="margin-left-5"
                size="22"
                indeterminate
                color="white"
              />
            </VBtn>
          </VCol>
        </VRow>
      </VCardText>
    </VCard>
  </VDialog>
</template>
